/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

export default function CanvaPortal({
  component: Component,
  props: componentProps = {},
  children
}: any) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const el = document.createElement("div");
    document.body.appendChild(el);
    // @ts-expect-error TS(2345): Argument of type 'HTMLDivElement' is not assignabl... Remove this comment to see the full error message
    setContainer(el);

    return () => {
      document.body.removeChild(el);
    };
  }, []);

  return (
    <>
      {children}
      {container && createPortal(<Component {...componentProps} />, container)}
    </>
  );
}
